/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let Bars: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M199.110656 284.444672c-31.418368 0-56.88832-25.469952-56.88832-56.889344 0-31.418368 25.469952-56.88832 56.88832-56.88832 31.419392 0 56.889344 25.469952 56.889344 56.88832 0 31.419392-25.469952 56.889344-56.889344 56.889344z m156.444672-99.555328h483.555328c23.564288 0 42.667008 19.101696 42.667008 42.665984 0 23.564288-19.10272 42.667008-42.667008 42.667008H355.555328c-23.564288 0-42.665984-19.10272-42.665984-42.667008s19.101696-42.665984 42.665984-42.665984z m0 284.443648h483.555328c23.564288 0 42.667008 19.10272 42.667008 42.667008s-19.10272 42.667008-42.667008 42.667008H355.555328c-23.564288 0-42.665984-19.10272-42.665984-42.667008s19.101696-42.667008 42.665984-42.667008z m0 284.444672h483.555328c23.564288 0 42.667008 19.10272 42.667008 42.667008s-19.10272 42.665984-42.667008 42.665984H355.555328c-23.564288 0-42.665984-19.101696-42.665984-42.665984 0-23.564288 19.101696-42.667008 42.665984-42.667008zM199.110656 568.889344c-31.418368 0-56.88832-25.470976-56.88832-56.889344s25.469952-56.889344 56.88832-56.889344C230.530048 455.110656 256 480.581632 256 512s-25.469952 56.889344-56.889344 56.889344z m0 284.443648c-31.418368 0-56.88832-25.469952-56.88832-56.88832 0-31.419392 25.469952-56.889344 56.88832-56.889344 31.419392 0 56.889344 25.469952 56.889344 56.889344 0 31.418368-25.469952 56.88832-56.889344 56.88832z"
        fill={getIconColor(color, 0, '#333333')}
      />
    </Svg>
  );
};

Bars.defaultProps = {
  size: 18,
};

Bars = React.memo ? React.memo(Bars) : Bars;

export default Bars;
